const SUBSCRIPTION_INTERACTION_URL =
  'https://medplum.com/fhir/StructureDefinition/subscription-supported-interaction';

export const CREATE_ONLY_OPTIONS = {
  subscriptionProps: {
    extension: [
      {
        url: SUBSCRIPTION_INTERACTION_URL,
        valueCode: 'create',
      },
    ],
  },
};

export const UPDATE_ONLY_OPTIONS = {
  subscriptionProps: {
    extension: [
      {
        url: SUBSCRIPTION_INTERACTION_URL,
        valueCode: 'update',
      },
    ],
  },
};

export const DELETE_ONLY_OPTIONS = {
  subscriptionProps: {
    extension: [
      {
        url: SUBSCRIPTION_INTERACTION_URL,
        valueCode: 'delete',
      },
    ],
  },
};
